module.exports = __webpack_public_path__ + "static/img/flow-icon2.95e3627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flow-icon2.png
// module id = sX/J
// module chunks = 1